import type { AbilityDef } from "../../sim";

/**
 * «Магический выстрел»: ← + △ — замах двумя руками и сгусток энергии через всю арену (Джон 04.11.2026, 22:29: «хочу
 * прям очень креативный разнообразный файтинг очень необычный»; клип Standing 2H Magic Attack 01). Снаряд — сущность
 * мира (sim/projectile.ts): один за раз, гаснет в стене, при попадании и при встрече со снарядом соперника.
 */
export const MAGIC_SHOT: AbilityDef = {
  id: "magic-shot",
  name: "Магический выстрел",
  input: { button: "heavyPunch", hold: "B" },
  pose: "magicShot",
  startup: 16,
  active: 1,
  recovery: 22,
  projectile: { speed: 9, box: { x: -18, y: -18, w: 36, h: 36 }, from: { x: 46, y: -118 } },
  hit: { damage: 60, hitstun: 18, blockstun: 12, hitstop: 9, push: 7, height: "mid", chip: 8 },
  fx: { start: "magic/cast", hit: "magic/hit", block: "magic/block" },
  sound: { start: "whoosh", hit: "hit-heavy" },
};
